'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var preferredLanguage = navigator.languages ? navigator.languages[0] : navigator.language;

var defaultLanguage = exports.defaultLanguage = preferredLanguage ? preferredLanguage.toLowerCase() : 'en-us';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-public/static-1.281/js/helpers/langHelper.js
// module id = 627
// module chunks = 177